import { createSelector } from 'reselect';

export const getUser = (state) => state.userData;

export const userGetUserPreloaderSC = createSelector(
  getUser,
  (userData) => userData.isUserPreloader
);

export const userIsAuthSC = createSelector(getUser, (userData) => userData.isAuth);

export const userIsOnlineSC = createSelector(
  getUser,
  (userData) => userData.isOnline
);

export const userGetCustomerSC = createSelector(
  getUser,
  (userData) => userData?.user || null
);

export const userGetUserIdSC = createSelector(
  getUser,
  (userData) => userData?.user?.id || null
);

export const userGetUserRoleSC = createSelector(
  getUser,
  (userData) => userData?.user?.role || null
);

export const userGetCartIdSC = createSelector(
  getUser,
  (userData) => userData?.user?.basketId || null
);

export const userGetCartSC = createSelector(
  getUser,
  (userData) => userData?.cart || null
);

export const userGetInvoiceSC = createSelector(
  getUser,
  (userData) => userData?.invoice || null
);

export const userGetNotificationsSC = createSelector(
  getUser,
  (userData) => userData?.notifications || null
);

export const userGetServerErrorSC = createSelector(
  getUser,
  (userData) => userData.serverErrors
);

export const userGetActiveSearchSC = createSelector(
  getUser,
  (userData) => userData.search
);

export const userGetCurrenteSearchSC = createSelector(
  getUser,
  (userData) => userData.searchResult
);

export const userGetShowroomsProductsSC = createSelector(
  getUser,
  (userData) => userData.showroomsProducts
);

export const userGetCurrentUserSC = createSelector(
  getUser,
  (userData) => userData.currentUser
);

export const userGetCurrentUserAvatarSC = createSelector(
  getUser,
  (userData) => userData.currentUserAvatar
);

export const userGetStripeTokenSC = createSelector(
  getUser,
  (userData) => userData.publicStripeToken
);

export const userGetLimitPopupSC = createSelector(
  getUser,
  (userData) => userData.isCartLimitPopupShow
);

export const userGetLimitCartSC = createSelector(
  getUser,
  (userData) => userData.isCartLimit
);

export const userGetCountrySC= createSelector(
  userGetCustomerSC,
  (customerData) => customerData.country
);

export const userGetLocaleSC = createSelector(
  getUser,
  (userData) => userData.locale
);

export const userGetPaymentStatusSC = createSelector(
  getUser,
  (userData) => userData.paymentStatus
);

export const userGetActivatedEmailShowSC = createSelector(
  getUser,
  (userData) => userData.isActivatedEmailModalShow
)

export const userGetPurchasesLimitSC = createSelector(
  getUser,
  (userData) => userData.puschasesLimit
)

export const userGetModalLoginShowSC = createSelector(
  getUser,
  (userData) => userData.isModalLoginShow
)

export const userGetModalSignupShowSC = createSelector(
  getUser,
  (userData) => userData.isModalSignupShow
)

export const userGetModalRecoveryShowSC = createSelector(
  getUser,
  (userData) => userData.isModalRecoveryShow
)

export const userGetPaymentDataSC = createSelector(
  getUser,
  (userData) => userData.paymentData
)

export const userGetUserBillsSC = createSelector(
  getUser,
  (userData) => userData.bills
)

export const userGetBillsPaginationAmountSC = createSelector(
  getUser,
  (userData) => userData.billsPaginationAmount
)

export const userGetPaidProjectsSC = createSelector(
  getUser,
  (userData) => userData.paidProjects
)

export const userGetPaidProductsSC = createSelector(
  getUser,
  (userData) => userData.paidProducts
);

export const userGetPaidSubscribeSC = createSelector(
  getUser,
  (userData) => userData.paidSubscribe
);

export const userGetUserPaidSubscribeSC = createSelector(
  getUser,
  (userData) => userData.userPaidSubscribe
);

export const userGetBillsLoadingSC = createSelector(
  getUser,
  (userData) => userData.billsLoading
)

export const userGetPurchasesLoadingSC = createSelector(
  getUser,
  (userData) => userData.purchasesLoading
)

export const userGetSearchPageSC = createSelector(
  getUser,
  (userData) => userData.searchPage
)

export const userGetDeviceTypeSC = createSelector(
  getUser,
  (userData) => userData.deviceType
)

export const userGetIsMobileScreenViewSC = createSelector(
  getUser,
  (userData) => userData.isMobileScreen
)

export const userGetIsVisibleSubFooterSC = createSelector(
  getUser,
  (userData) => userData.isVisibleSubfooter
)

export const userGetCartLoadingSC = createSelector(
  getUser,
  (userData) => userData.isCartLoading
)

export const userGetFreeProductPopupSC = createSelector(
  getUser,
  (userData) => userData.isModalGetFreeShow
)

export const userGetSubscribePopupSC = createSelector(
  getUser,
  (userData) => userData.isModalSubscribeShow
)

export const userGetCurrentFreeProductSC = createSelector(
  getUser,
  (userData) => userData.currentFreeProduct
)

export const userGetTipAmountSC = createSelector(
  getUser,
  (userData) => userData.tipAmount
)

export const userGetFiltersStatusSC = createSelector(
  getUser,
  (userData) => userData.statusFilters
)